import PropTypes from "prop-types";
import Switch from "common/components/elements/inputs/switch";
// import "./style.scss";
import Icon from 'common/components/elements/icons';
import Filter from 'common/components/responsive/filter';

const Content = ({ value, onChange, isMobile }) => {
   const settingsList = [
      { id: 'content_cards_like', name: 'Like', icon: 'heart-outline2' },
      { id: 'content_cards_new_label', name: 'New label', icon: 'label' },
      { id: 'content_cards_share', name: 'Share', icon: 'share' },
      { id: 'content_cards_views', name: 'Story views', icon: 'views' },
      { id: 'content_cards_timestamp', name: 'Timestamp', icon: 'timer1' },
      { id: 'content_cards_timestamp', name: 'Timestamp', icon: 'timer1' },
      { id: 'content_cards_tip', name: 'Tip', icon: 'tip' },
      { id: 'content_cards_total_comment_counts', name: 'Total comment counts', icon: 'comment' },
      { id: 'content_cards_watched_unwatched_label', name: 'Watched/Unwatched label', icon: 'views' },
      { id: 'content_cards_most_liked_lebel', name: 'Most liked label', icon: 'label' },
      { id: 'content_cards_most_shared_lebel', name: 'Most shared label', icon: 'label', days: '' },
      { id: 'content_cards_top_10', name: 'Top 10', icon: 'label' },
      { id: 'content_cards_total_like_counts', name: 'Total like counts', icon: 'heart-outline2' },
      { id: 'content_cards_total_tip_amount', name: 'Total tip amount', icon: 'tip' },
      { id: 'content_cards_unlock_count_and_earnings', name: 'Unlock count & earnings', icon: 'unlocked' },

   ]
   const days = [
      { name: '7 days', value: 7 },
      { name: '14 days', value: 14 },
      { name: '21 days', value: 21 },
   ]

   const changeSettings = (name, value) => {
      onChange(name, value)
   }


   return (
      <div className='flex flex-col'>
         {
            settingsList.map(setting => {
               const checked = !!value?.[setting?.id]
               return (
                  <div className='flex justify-between py-[10px]'>
                     <div className='flex gap-3'>
                        <div className='w-5 h-5 flex items-center justify-center'>
                           <Icon name={ setting.icon } color='secondary' size='lg' />
                        </div>
                        <span className='leading-[20px] text-major font-normal text-base'>
                           {setting.name}
                           {
                              'content_cards_new_label' === setting.id &&  checked && (
                                 <div className='w-full flex flex-col gap-2'>
                                    <p className='text-xs text-secondary'>Show label for:</p>
                                    <div className='flex gap-2 w-full'>
                                       <Filter
                                          data={ days }
                                          height='10'
                                          desktopType={ isMobile < 700 ? 'mobile' : 'desktop' }
                                          onFilterChange={ (a, b) => {
                                             changeSettings(`content_cards_new_label_days`, a)
                                          } }
                                          className={ `text-base w-fit` }
                                          padding={ `px-4` }
                                          bgColor={ `transparent` }
                                          showNewStyles={ true }
                                          contentStyles={ { width: '200px', top: '44px', left: '0' } }
                                          activeSelectedValue={ days.find(day => day.value === value?.[`content_cards_new_label_days`]) }
                                          contentCardsStyle={ {
                                             fontSize: '16px',
                                             forContent: true,
                                          } }
                                          version='v2'
                                          hasClearButton={ false }
                                          showClearButton={ false }
                                       />
                                    </div>
                                 </div>
                              )
                           }
                        </span>
                     </div>
                     <Switch
                        name={ setting.id }
                        onChange={ (id, value) => {
                           changeSettings(id, value)
                        }
                        }
                        checked={ checked }
                        className='h-5'
                     />
                  </div>
               )
            })
         }

      </div>
   )
};

Content.propTypes = {
   value: PropTypes.object,
   onChange: PropTypes.func,
   isMobile: PropTypes.bool,
};

export default Content;
